/*
A plugin for Corrector to allow users to categorize corrections
 */
class CorrectorCategoriesPlugin extends CorrectorPlugin {

	constructor(element, options = {}) {
		const defaultOptions = {
			categories: [],
			categoryColorClasses: {},
			categoryClass: "corrector-category",
			classForSelectedCategory : "corrector-category-selected",
			emptyCategory: Corrector._t("Highlight"),
			correctorHighlight: 'span.corrector-highlight'
		};

		super(element, $.extend(defaultOptions, options));
		this.element = element;
	}

	properties() {
		super.properties();

		this.events = this.events || {};
		this.events = $.extend(this.events, {
			'.corrector-category click' : "changeSelectedCategory",
			'correctionEditorSubmit'    : "saveCategory",
			'correctionEditorShown'     : "highlightSelectedCategory",
			'correctionsLoaded'         : 'changeHighlightColors'
		});

		// The field element added to the CorrectorEditor wrapped in jQuery. Cached to
		// save having to recreate it everytime the editor is displayed.
		this.field = null;

		// The input element added to the CorrectorEditor wrapped in jQuery. Cached to
		// save having to recreate it everytime the editor is displayed.
		this.input = null;

		this.widthSet = false;
	}

	/*
	 PUBLIC: Initialises the plugin and adds categories field wrapper to corrector wrapper (editor and viewer)

	 Returns nothing.
	*/
	pluginInit() {
		if (!Corrector.supported()) { return; }

		this.options.categoryColorClasses[this.options.emptyCategory] = this.options.categoryClass + '-none';
		this.field = this.corrector.editor.addField({
			label: Corrector._t('Category'),
			options: this.options
		});

		// Add support for touch devices
		$(document).delegate(".corrector-category", "tap", {preventDefault: false}, this.changeSelectedCategory.bind(this));

		this.corrector.viewer.addField({
			load: this.updateViewer.bind(this),
			options: this.options
		});

		this.input = $(this.field).find(':input');

		this.changeHighlightColors();
	}

	changeHighlightColors(corrections) {
		// Update the highlight colors for all categorized corrections
		// Called after all corrections loaded

		let i = 0;
		for (const category of this.options.category) {
			this.options.categoryColorClasses[category] = this.options.categoryClass + '-' + i;
			i++;
		}

		if (typeof corrections === 'undefined' || corrections == null) {
			return;
		}

		for (const correction of corrections) {
			// check if category is empty
			if ((correction.category == null) || !correction.category.length) {
				correction.category = this.options.emptyCategory;
			}
			for(const highlight of correction.highlights) {
				$(highlight).addClass(this.options.categoryColorClasses[correction.category]);
			}
		}
	}

	setSelectedCategory(currentCategory) {
		// Change the selected category in the editor window

		// clear any selection
		$(this.field).find('.corrector-category').removeClass(this.options.classForSelectedCategory);

		// add CSS to new selection
		$(this.field).find('.corrector-category:contains(' + currentCategory + ')').addClass(this.options.classForSelectedCategory);
	}

	updateViewer(field, correction) {
		// On mouseover, gets the correction object
		// For displaying mouseover data
		field = $(field);
		field.addClass(this.options.categoryClass).html(this.options.emptyCategory);

		// if !correction.category? correction.category = @options.emptyCategory
		if ((correction.category != null) && (correction.category.length > 0)) {
			field.addClass(this.options.categoryClass).html(correction.category);
			if (this.options.category.includes(correction.category)) {
				field.addClass(this.options.categoryColorClasses[correction.category]);
			}
		}
	}

	changeSelectedCategory(event) {
		// HTML contains the string with the name of the category
		const category = $(event.target).html();
		this.setSelectedCategory(category);
	}

	saveCategory(event, correction) {
		// Find currently selected category; grab the string and save it
		// We prepend the . to tell jQuery this is a class we're seeking
		correction.category = $(this.field).find('.' + this.options.classForSelectedCategory).html();
		if ( (correction.text != null) && (correction.text.length > 0) && (correction.category == null) ) {
			// TODO: force a choice
			window.alert(Corrector._t('You did not choose a category, so the default has been chosen.'));
			correction.category = this.options.category[0];// default is first category
		}
		if ((correction.category == null) || !correction.text) {
			correction.category = this.options.emptyCategory;
		}
		this.changeHighlightColors([correction]);
	}

	highlightSelectedCategory(event, correction) {
		// when editor first shown
		let category;
		if ((correction.category == null)) {
			correction.category = this.options.emptyCategory;
		}

		let categoryHTML = "";
		for (category of this.options.category) {
			categoryHTML += '<span class="' + this.options.categoryClass;
			categoryHTML += ' ' + this.options.categoryColorClasses[category] + '">';
			categoryHTML += category;
			categoryHTML += '</span>';
		}
		$(this.field).html(categoryHTML);

		if (!this.widthSet) {
			// Only set the width once
			this.widthSet = true;
			let totalWidth = 5;  // for a tiny bit of extra padding
			// Sum up widths of each category.
			$("span.corrector-category").each(function(index) {
				totalWidth += parseInt($(this).outerWidth(true), 10);
			});
			// Set widget width
			$(".corrections-editor .corrector-widget").width(totalWidth);
		}

		this.setSelectedCategory(correction.category);

	}


}
CorrectorPlugin.Categories = CorrectorCategoriesPlugin;
